import React from 'react';

// Milestone Update 右侧icon的hover提示
export const MilestoneDateTips = () => (
  <div style={{ fontSize: 14 }}>
    <p>If you are uncertain about the exact date, opt for</p>
    <p>the last day of the quarter to signify the entire</p>
    <p>quarter, and similarly, choose the final day of the</p>
    <p>month to represent that month.</p>
  </div>
);
